// extracted by mini-css-extract-plugin
export default {"column-list-adapter":"column-list-adapter--2NA2E1Dy30","columnListAdapter":"column-list-adapter--2NA2E1Dy30"};